/**
 * Returns today's date as YYYY-MM-DD in the user's LOCAL timezone.
 * new Date().toISOString() always returns UTC, which is wrong for anyone
 * whose clock is behind UTC (e.g. all US timezones).
 */
export function localToday() {
  const d = new Date();
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, '0'),
    String(d.getDate()).padStart(2, '0'),
  ].join('-');
}

/**
 * Returns the browser's timezone offset in minutes.
 * Matches JS Date.getTimezoneOffset() convention:
 *   positive = west of UTC  (e.g. UTC-5 → 300)
 *   negative = east of UTC  (e.g. UTC+5 → -300)
 */
export function tzOffset() {
  return new Date().getTimezoneOffset();
}